import React from 'react';
import Tittle from '../Components/Tittle';
import allBlogs from '../Components/allBlogs';
import { Link } from 'react-router-dom';

function BlogsPage() {
    return (
        <div >
            <div className="b-title">
                <Tittle title={'Recent Projects'} span={'Recent Projects'} />
            </div>
            <div className="BlogsPage">
                {
                    allBlogs.map((blog) => {
                        return <div className="blog" key={blog.id}>
                            <div className="blog-content">
                                <img src={blog.image} alt="" style={{ height: '300px' }} />
                                <h2>
                                    Name: {blog.title}
                                </h2>


                                <p>
                                    <button className="btn btn-danger" style={{ width: 'fitcontent', padding: '10px', borderRadius: '5px', margin: '2px' }}><Link style={{ textDecoration: 'none', color: 'white' }} to={blog.projects}>{blog.details}</Link></button>
                                    <button className="btn btn-danger" style={{ width: 'fitcontent', padding: '10px', borderRadius: '5px', margin: '2px' }}><a style={{ textDecoration: 'none', color: 'white' }} href={blog.link}>{blog.live}</a></button>
                                    <button className="btn btn-danger" style={{ width: 'fitcontent', padding: '10px', borderRadius: '5px', margin: '2px' }}><a style={{ textDecoration: 'none', color: 'white' }} href={blog.linkgc}>{blog.git}</a></button>
                                    <button className="btn btn-danger" style={{ width: 'fitcontent', padding: '10px', borderRadius: '5px', margin: '2px' }}><a style={{ textDecoration: 'none', color: 'white' }} href={blog.linkgs}>{blog.gits}</a></button>
                                </p>
                            </div>
                        </div>
                    })
                }
            </div>

        </div>
    )
}

export default BlogsPage;
